/**
 * Shared billing display utilities.
 */

import type { InvoiceStatus, SubscriptionStatus } from '@upskill/shared';

/** Format a monetary amount as "CURRENCY amount" e.g. "USD 1200.00" */
export function formatAmount(amount: number, currency: string): string {
  return `${currency} ${amount.toFixed(2)}`;
}

/** Badge variant for each SubscriptionStatus — shared across billing pages. */
export const SUBSCRIPTION_STATUS_VARIANT: Record<
  SubscriptionStatus,
  'success' | 'warning' | 'error' | 'neutral'
> = {
  PENDING: 'neutral',
  ACTIVE: 'success',
  PAST_DUE: 'warning',
  CANCELED: 'error',
  EXPIRED: 'neutral',
};

/** Badge variant for each InvoiceStatus — shared across billing pages. */
export const INVOICE_STATUS_VARIANT: Record<
  InvoiceStatus,
  'success' | 'warning' | 'error' | 'neutral'
> = {
  DRAFT: 'neutral',
  ISSUED: 'warning',
  PAID: 'success',
  VOID: 'error',
};
